interface PDPSeoBreadcrumbSchemaProps {
    breadcrumbsData: string[];
}
export const PDPSeoBreadcrumbSchema = ({ breadcrumbsData }: PDPSeoBreadcrumbSchemaProps) => {
    const itemListElement = breadcrumbsData.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item,
        item: `${process.env.NEXT_PUBLIC_BASEPATH}/${breadcrumbsData.slice(0, index + 1).join("/")}`,
    }));

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: itemListElement,
    };
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
    );
};
